// PORTUGUÊS

export default {
    values: {
        'Type to search': 'Digite para buscar',
        REMOVE: 'REMOVER',
        Creating: 'Criando',
        Create: 'Criar',
        Close: 'Fechar',
        Cancel: 'Cancelar',
        'Confirm deletion': 'Confirmar deleção',
        'No, I do not': 'Não tenho certeza',
        of: 'de',
        items: 'itens',
        Default: 'Padrão',
        Ascending: 'Ascendente',
        Descending: 'Descendente',
        All: 'Tudo',
        Description: 'Descrição',
        Name: 'Nome',
        Save: 'Salvar',
        Asset: 'Ativo',
        ASSET: 'ATIVO',
        Responsible: 'Responsável',
        'Live Event Id': 'Id de evento do Live',
        Showing: 'Mostrando',

        /* ---------------------------------------------------------------------------------------------------------- */

        // FETCH ERROR
        'An error occurred on get operations.': 'Ocorreu um erro ao buscar as operações.',
        'An error occurred on create diagram.': 'Ocorreu um erro ao criar o diagrama.',
        'An error occurred on list bowties.': 'Ocorreu um erro ao buscar a lista de bowties.',
        'An error occurred on get barrier status.': 'Ocorreu um erro ao buscar o status das barreiras.',
        'An error occurred on get bowtie.': 'Ocorreu um erro ao buscar o bowtie.',
        'Diagram saved successfully.': 'Diagrama salvo com sucesso.',
        'Error on save barrier.': 'Erro ao salvar a barreira.',
        'Error on save bowtie.': 'Erro ao salvar o bowtie.',
        'An error occurred on register supervisor': 'Ocorreu um erro ao registrar o novo supervisor',
        // END FETCH ERROR

        /* ---------------------------------------------------------------------------------------------------------- */

        // FETCH SUCCESSFULLY
        'Error on save diagram.': 'Erro ao salvar o diagrama.',
        'Barrier saved successfully.': 'Barreira salva com sucesso.',
        'Bowtie saved successfully.': 'Bowtie salvo com sucesso.',
        // END FETCH SUCCESSFULLY

        /* ---------------------------------------------------------------------------------------------------------- */

        // BOWTIE GENERAL
        THREAT: 'AMEAÇA',
        Threats: 'Ameaças',
        Threat: 'Ameaça',
        threat: 'ameaça',

        Barriers: 'Barreiras',
        Bowties: 'Bowties',
        Diagrams: 'Diagramas',

        PREVENTION: 'PREVENÇÃO',

        HAZARD: 'PERIGO',
        Hazard: 'Perigo',

        MITIGATION: 'MITIGAÇÃO',

        CONSEQUENCE: 'CONSEQUÊNCIA',
        Consequences: 'Consequências',
        Consequence: 'Consequência',
        consequence: 'consequência',

        'Top Event': 'Evento Topo',
        'TOP EVENT': 'EVENTO TOPO',
        TOPEVENT: 'EVENTO TOPO',

        'Initial Freq.': 'Freq. Inicial',
        'Final Freq.': 'Freq. Final',
        'Tolerable Freq.': 'Freq. Tolerável',
        'Threshold Freq.': 'Freq. Limite',

        BARRIER: 'BARREIRA',
        BARRIERS: 'BARREIRAS',
        Barrier: 'Barreira',

        'Refresh Barriers': 'Recarregar Barreiras',

        'ESCALATION FACTOR': 'FATOR DE ESCALONAMENTO',
        'Escalation Factor': 'Fator de Escalonamento',
        'Escalation Factors': 'Fatores de Escalonamento',
        'Enabled degradation criterias:': 'Critérios de degradação ativados:',

        Marine: 'Marítimo',
        Drilling: 'Perfuração',
        Emergency: 'Emergência',
        marine: 'Marítimo',
        drilling: 'Perfuração',
        operation: 'Operação',
        emergency: 'Emergência',

        'System ID': 'ID do Sistema',
        // END BOWTIE GENERAL

        /* ---------------------------------------------------------------------------------------------------------- */

        // RISK MANAGEMENT EDITOR
        Active: 'Ativa',
        'All Operations': 'Todas as Operações',
        'Select Resource': 'Selecione o Recurso',
        RESOURCE: 'RECURSO',
        'Leave without saving': 'Sair sem salvar',
        'ESCALATION BARRIER': 'BARREIRA DE ESCALONAMENTO',
        'Barrier Category': 'Categoria de Barreira',
        Criticality: 'Criticidade',
        Criticity: 'Criticidade',
        'LIST OF ENTITIES': 'LISTA DE ENTIDADES',
        Operation: 'Operação',
        OPERATION: 'OPERAÇÃO',
        'Risk Management': 'Gestão de Risco',
        'Risk Diagram': 'Diagrama de Risco',
        'This action cannot be undone.': 'Esta ação não pode ser desfeita.',
        'Features that read this list will be affected.': 'Funcionalidades que utilizam esta lista serão afetadas.',
        'in the field below before completing the action:': 'no campo abaixo antes de completar a ação:',
        'Bowtie Editor': 'Editor Bowtie',
        'YOU DO NOT HAVE PERMISSION TO ACCESS THE EDITOR.': 'VOCÊ NÃO POSSUI PERMISSÃO PARA ACESSAR O EDITOR.',
        'YOU DO NOT HAVE PERMISSION TO ACCESS THE BOWTIE SETTINGS.':
            'VOCÊ NÃO POSSUI PERMISSÃO PARA ACESSAR AS CONFIGURAÇÕES DE BOWTIE.',
        'Are you sure you want to leave without saving your work?':
            'Tem certeza que deseja sair sem salvar seu trabalho?',

        /// RISK MANAGEMENT EDITOR - DIAGRAMS LIST
        'New Diagram': 'Novo Diagrama',
        'Create new diagram': 'Criar novo diagrama',
        'There are no diagrams yet': 'Ainda não há diagramas',
        'Are you sure you want remove the diagram': 'Tem certeza que quer remover o diagrama',
        'If you really want to delete the diagram, type': 'Se realmente quer deletar o diagrama, digite',
        'Delete diagram': 'Deletar diagrama',
        'diagram deleted.': 'Diagrama deletado.',
        /// End RISK MANAGEMENT EDITOR - DIAGRAMS LIST

        /// RISK MANAGEMENT EDITOR - BARRIERS LIST
        'New Barrier': 'Nova Barreira',
        'Are you sure you want remove the barrier': 'Tem certeza que quer remover a barreira',
        'If you really want to delete the barrier, type': 'Se realmente quer deletar a barreira, digite',
        'Delete barrier': 'Deletar barreira',
        'Load more': 'Carregar mais',

        'barrier deleted.': 'Barreira deletada.',
        'Please insert a different name when copying barrier':
            'Ao copiar uma barreira, favor inserir um nome diferente do original',
        /// End RISK MANAGEMENT EDITOR - BARRIERS LIST

        /// RISK MANAGEMENT EDITOR - BOWTIE LIST
        'New Bowtie': 'Novo Bowtie',
        'Create new Bowtie': 'Criar novo Bowtie',
        'There are no Bowties yet': 'Ainda não há Bowties',
        'Are you sure you want remove the bowtie': 'Tem certeza que quer remover o bowtie',
        'If you really want to delete the bowtie, type': 'Se realmente quer deletar o bowtie, digite',
        'Delete bowtie': 'Deletar bowtie',
        'bowtie deleted.': 'Bowtie deletado.',
        /// END RISK MANAGEMENT EDITOR - BOWTIE LIST

        /// RISK MANAGEMENT EDITOR - DIAGRAM EDITOR
        'A risk diagram must have at least one threat and at least one consequence.':
            'O diagrama de risco deve ter ao menos uma Ameaça e uma Consequência.',
        'Threat must have a valid name': 'A Ameaça deve ter um nome valido',
        'Consequence must have a valid name': 'A Consequência deve ter um nome valido',
        'must have a valid name': 'deve ter um nome válido',
        'Threat must have a valid initial frequency': 'A Ameaça deve ter uma frequência válida',
        'must have a valid initial frequency': 'deve ter uma frequência inicial válida',
        'must have a valid threshold frequency': 'deve ter uma frequência limite válida',
        'Top event must have a valid name': 'O Evento Topo deve ter um nome válido',
        'Hazard must have a valid name': 'O Perigo deve ter um nome válido',
        'Value Between 0 and 1': 'Valor entre 0 e 1',
        'Initial Frequency': 'Frequência Inicial',
        'Final Frequency': 'Frequência Final',
        'Initial PFD': 'PFD Inicial',
        'Final PFD': 'PFD Final',

        /// END RISK MANAGEMENT EDITOR - DIAGRAM EDITOR

        /// RISK MANAGEMENT EDITOR - BARRIER EDITOR
        'Please select barrier category and barrier': 'Por favor, selecione a categoria de barreira e a barreira',
        'Entities with errors': 'Entidades com erro',
        'Barrier Update Mode': 'Modo de Atualização de Barreira',
        Method: 'Método',
        Quantitative: 'Quantitativo',
        Qualitative: 'Qualitativo',
        'NORMALIZATION TITLE': 'QUANTIZADOR',
        'add escalation': 'adicionar escalonamento',
        Deadline: 'Tempo limite',
        'Manual barrier is on indefinitely unless deadline is set.':
            'Barreira manual acionada indefinidamente, a menos que o tempo limite seja definido',
        'Manual Barrier Status Interaction': 'Barreira com status de interação manual',
        'External Related Links': 'Links externos relacionados',
        Label: 'Etiqueta',
        'Add Link': 'Adicionar Link',
        /// END RISK MANAGEMENT EDITOR - BARRIER EDITOR

        /// RISK MANAGEMENT EDITOR - BOWTIE EDITOR
        'Safety Critical Barrier (Optional)': 'Barreira Crítica para Segurança (Opcional)',
        'Bowtie Mandatory Barrier': 'Mandatória para o Bowtie (Pré-Operacional)',
        'Threat Mandatory Barrier': 'Mandatória para a Ameaça',
        'Consequence Mandatory Barrier': 'Mandatória para a Consequência',
        'Once The Threat Mandatory Barrier option is selected the inactivation of it will lead to the inactivation of the whole Bowtie Web that it belongs. \nOnce The Bowtie Mandatory Barrier option is selected the inactivation of it will lead to the Top Event Occurrence directly, because it is an operational prerequisite':
            'Uma vez que a opção de barreira mandatória para a ameaça é selecionada, a inativação da mesma vai levar a inativação de todo a cadeia de Bowtie a qual pertence. \nUma vez que a opção de barreira mandatória para o Bowtie é selecionada, a inativação da mesma vai levar a ocorrencia do Evento Topo diretamente, pois é um pré-requisito operacional',
        'Once The Consequence Mandatory Barrier option is selected the inactivation of it will lead to the Top Event Occurrence directly, because it is an operational prerequisite':
            'Uma vez que a opção de barreira mandatória para a Consequência é selecionada, a inativação da mesma vai levar a ocorrencia do Evento Topo diretamente, pois é um pré-requisito operacional',
        'Changes made in this interface will occur just in this Bowtie':
            'Mudanças realizadas nesta interface ocorrerão apenas neste Bowtie',
        /// END RIS MANAGEMENT EDITOR - BOWTIE EDITOR
        // END RISK MANAGEMENT EDITOR

        /* ---------------------------------------------------------------------------------------------------------- */

        // BOWTIE VISUALIZATION
        'Degraded Barriers': 'Barreiras Degradadas',
        'active barriers': 'barreiras ativas',
        'Inactive Barriers': 'Barreiras Inativas',
        'Effectiveness Top': 'Limite Superior',
        'Effectiveness Bottom': 'Limite Inferior',
        'Refers to the quantity of barriers with any degradation (including the inactive ones).':
            'Refere a quantidade de barreiras com qualquer degradação (incluindo as inativas).',
        'Refers to the % of barriers that are not inactive and/or unknown status.':
            'Refere a % de barreiras que não estão inativas e/ou não possuem status desconhecido.',
        'No event': 'Sem evento',
        // END BOWTIE VISUALIZATION

        /* ---------------------------------------------------------------------------------------------------------- */

        /* OVERVIEW */
        degraded: 'degradada',
        Degraded: 'Degradada',
        Inactive: 'Inativa',
        inactive: 'inativa',
        INACTIVE: 'INATIVA',
        ACTIVE: 'ATIVA',
        DEGRADED: 'DEGRADADA',
        active: 'ativo',
        MANAGER: 'GERENTE',
        Unknown: 'Desconhecido',
        'BOWTIES WITH DEGRADED BARRIERS': 'BOWTIES COM BARREIRAS DEGRADADAS',
        'Go to bowtie editor': 'Ir para o Editor Bowtie',
        Acceptable: 'Aceitável',
        Tolerable: 'Tolerável',
        Unacceptable: 'Inaceitável',
        Evidences: 'Evidências',
        Intolerable: 'Intolerável',
        'Invalid event': 'Evento inválido',
        'inactive barriers': 'barreiras inativas',
        'This is a custom client overview. It does not follow the original product standard.':
            'Overview customizado para cliente. Não segue o padrão original do produto.',
        /* END OVERVIEW */

        /* HELP MODAL */
        Help: 'Ajuda',
        'Bowtie interaction': 'Interação com o Bowtie',
        'human barrier': 'barreira humana',
        'physical barrier': 'barreira física',
        'administrative barrier': 'barreira organizacional',
        'High criticality': 'Alta criticidade',
        'Identifies a critical barrier.': 'Identifica uma barreira crítica.',
        'Dashboard action items': 'Itens de ação do dashboard',
        'Toggle language': 'Mudar idioma',
        'Open help modal': 'Abrir modal de ajuda',
        'Highlight inactive and unknown barriers': 'Destacar barreiras inativas e desconhecidas',
        'Open first barriers level': 'Abrir barreiras de primeiro nível',
        'Close all barriers': 'Fechar todas as barreiras',
        'Reset zoom and position': 'Redefinir zoom e posição',
        'Zoom in': 'Ampliar zoom',
        'Zoom out': 'Reduzir zoom',
        'Reset zoom': 'Redefinir zoom',
        'Edit this bowtie': 'Editar este bowtie',
        Search: 'Buscar',
        Settings: 'Configurações',

        /** SETTINGS */
        'Alarp Description':
            'ALARP significa "tão baixo quanto razoavelmente praticável" e está diretamente relacionado ao Risco Residual. ALARP mostra uma imagem do nível de segurança que foi considerado naquele momento e é uma definição de nível de tolerância: inaceitável, tolerável e totalmente aceitável.',
        'Quantitative Description':
            'Método quantitativo: dados quantitativos são usados para quantificar um problema por números. Esses dados podem ser contados ou comparados em uma escala numérica. O método quantitativo contém número para quantificar a PFD - Probabilidade de Falha sob Demanda, baseada no valor relativo de PFD Inicial.',
        'Qualitative Description':
            'Método qualitativo: dados qualitativos podem ser definidos como dados não numéricos, abordagem booleana ou percentual. A saída do método qualitativo do processo será um estado de degradação baseado em critérios booleanos.',
        'Absolute Quantitative Description':
            'Dados quantitativos são utilizados para quantificar um problema por números. Esses dados podem ser contados ou comparados em uma escxala numérica. O método quantitativo contém números para quantificar o PFD - Probabilidade de Falha sobre Demanda (Inicial, Final e Threshold)',
        'QUANTITATIVE METHOD': 'MÉTODO QUANTITATIVO',
        'QUALITATIVE METHOD': 'MÉTODO QUALITATIVO',
        'NORMALIZATION METHOD':
            'Barreira qualitativa em um Bowtie quantitativo (Bowtie híbrido) é uma barreira qualitativa inserida em uma trama, ou ramo ou em um Bowtie de barreiras Quantitativas. A barreira qualitativa possui um valor subjetivo para avaliar seu status. Este valor subjetivo chamado de efetividade (QLR) é quantificado em um valor de probabilidade de demanda (PFD) a partir das definições de configuração dada pelo usuário.',
        CATEGORY_UNMONITORED_DESCRIPTION:
            'Esta categoria corresponde a barreiras que não são monitoradas (em geral de terceiros) seja por sensor, por evento, manualmente ou outro método de atualização. Ou seja, o usuário não recebe nenhuma atualização de dados em tempo real.',
        ICON: 'ÍCONE',
        CATEGORY: 'CATEGORIA',
        DESCRIPTION: 'DESCRIÇÃO',
        AUTHOR: 'AUTOR',
        'LAST CHANGED': 'ÚLTIMA ATUALIZAÇÃO',
        'New Category': 'Nova Categoria',
        'Barrier Categories': 'Categorias de Barreira',
        'Alarp Levels': 'Níveis de Alarp',
        Color: 'Cor',
        'Highest acceptable level of risk': 'Nível de risco mais alto aceitável',
        'Generally acceptable level of risk': 'Nível de risco geralmente aceitável',
        'Risk Rate': 'Taxa de Risco',
        'New Rule': 'Nova Regra',
        Unmonitored: 'Não Monitorado',
        'Unmonitored Description':
            'Obs.: Por ser uma barreira sem monitoramento, esta categoria não exige cálculo de status. Por esta razão, não será possível configurar regras de negócio e os campos relativos aos intervalos de PFD estarão desabilitados na interface. Elas possuirão um status único, que receberá o mesmo nome da categoria, junto a cor específica para sua identificação.',

        /** REPORTS **/
        REPORTS: 'RELATÓRIOS',
        Report: 'Relatório',
        SETTINGS: 'CONFIGURAÇÕES',
        PRESETS: 'MODELOS DE RELATÓRIO',
        'Risk Acceptance / Risk Level': 'Nível de aceitação / Nível de Risco',
        'Resource Threat Status': 'Status da Ameaça do Recurso',
        'Resource Barrier Status': 'Status da Barreira do Recurso',
        'Resource Barrier PFD': 'PFD da Barreira do Recurso',
        'Current Mandatory Barriers': 'Barreira Mandatória Vigente',
        'Manual Interaction Barriers Status': 'Status da Barreira de Interação Manual',
        TIMESPAN: 'SELETOR DE TEMPO',
        'SELECT THE TIMESPAN': 'SELECIONE O INTERVALO DE TEMPO',
        Start: 'Início',
        End: 'Final',
        to: 'até',
        resource: 'recurso',
        'bowtie code': 'código do bowtie',
        'bowtie name': 'nome do bowtie',
        'risk level status': 'nível de risco',
        'date/time': 'data/hora',
        'YYYY/MM/DD': 'AAAA/MM/DD',
        'threat name': 'nome da ameaça',
        'inherent risk': 'risco inerente',
        Yesterday: 'Ontem',
        'Last day': 'Último dia',
        'Last 15 days': 'Últimos 15 dias',
        'Last week': 'Última semana',
        'Last month': 'Último mês',
        'Last quarter': 'Último trimestre',
        'Last semester': 'Último semestre',
        'Last year': 'Último ano',
        Apply: 'Aplicar',
        Clear: 'Limpar',
        page: 'página',
        'All time': 'Todo tempo',
        'Select a preset and a time range to view a report':
            'Selecione um modelo pré definido e um intervalo de tempo para visualisar o relatório',
        'initial frequency': 'frequência inicial',
        'final frequency': 'frequência final',
        'barrier id': 'id da barreira',
        'barrier name': 'nome da barreira',
        'safety critical': 'segurança crítica',
        responsible: 'responsável',
        'Selected filters': 'Filtros selecionados',
        'Clear  all': 'Limpar todos',
        category: 'categoria',
        'entity name': 'nome da entidade',
        'initial pfd': 'pfd inicial',
        'final pfd': 'pfd final',
        threshold: 'limite',
        'Threshold Frequency': 'Frequência Limite',
        'PFD Max': 'PFD Máx',
        'Lowly degraded': 'B.Degradada',
        LOW_DEGRADED: 'B.DEGRADADA',
        HIGHLY_DEGRADED: 'A.DEGRADADA',
        HIGH_DEGRADED: 'A.DEGRADADA',
        'Highly degraded': 'A.Degradada',
        unmonitored: 'não monitorada',
        UNMONITORED: 'NÃO MONITORADA',
        'Resource Barrier Analysis': 'Análise da Barreira do Recurso',
        'time interval': 'intervalo de tempo',
        'Time Interval': 'Intervalo de tempo',
        'time gathered': 'tempo reunido',
        'Select an item from the list to view the graphic': 'Selecione um item da lista para visualizar o gráfico',
        Graphic: 'Gráfico',
        END: 'FINAL',
        START: 'INÍCIO',

        /** System audit */
        'An error occurred on listing audit logs': 'Ocorreu um erro ao listar os registros de auditoria',
        'No data for the selected period. Select a different timespan and try again.':
            'Sem dados no período selecionado. Selecione um intervalo de tempo diferente e tente novamente.',
        FILTERS: 'FILTROS',
        EXPORT: 'EXPORTAR',
        'Generate Report': 'GERAR RELATÓRIO',
        'Clean Filters': 'LIMPAR FILTROS',
        Download: 'Baixar',
        'DOWNLOAD DATA': 'BAIXAR DADOS',
        Successful: 'Sucesso',
        Error: 'Erro',
        'Client Error': 'Erro no Cliente',
        'Server Error': 'Erro no Servidor',
        Redirection: 'Redirecionamento',
        Informational: 'Informativo',
        'Request Method': 'Método de requisição',
        'Please, enter a time range': 'Por favor, insira um intervalo de tempo',
        'An error occurred on export data': 'Um erro ocorreu ao exportar os dados',

        /** END */

        'Restore defaults': 'Restaurar padrões',
        'PDF export only shows the latest 300 requisitions':
            'A exportação de PDF mostra apenas as últimas 300 requisições',
        'Server response': 'Resposta do sistema',
        'Server payload': 'Requisição ao sistema'
    }
}
